import { render, staticRenderFns } from "./ImmuneTestDetails.vue?vue&type=template&id=2f230e9a&"
import script from "./ImmuneTestDetails.vue?vue&type=script&lang=js&"
export * from "./ImmuneTestDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports